export function getInitialTempName(fileName, hasEdited) {
  const ext = fileName.split('.').pop();
  return hasEdited ? fileName.replace(new RegExp(`\\.${ext}$`), '') : fileName;
}


